export const BASE_URL = "https://api.Loopapot.com:5001";
export const API_BASE_URL = `${BASE_URL}/api`;
export const SOCKET_URL = 'https://sglr.Loopapot.com:3000';
// export const SOCKET_URL = 'http://192.168.1.7:3000';
// export const SOCKET_URL = 'http://192.168.1.20:3000'; //v
export const SIGNALR_URL = `${BASE_URL}/chatHub`;
export const NOTIFICATION_API_BASE_URL = `https://fcm.googleapis.com/v1/projects/starmeet-daec0/messages:send`;
export const DEFAULT_LOCALE = "en";
export const FCMTOKEN = "cuRBgMLCT1qKTMfW6cw3hD:APA91bG0xLnMh9k29TzxIdsvjkXvIRDbmTH-rE9ZDK2JAJ-1Y0UsP8QJ4b7-3bXJD4TTcr2on4DBFy4Q7lDlWWUuTg8ShCfvEdSOsnVTUKFK5XU9wJSTlzTl-LenTcDhtHup5766g6ZU";
export const IMAGE_URL = "https://download.Loopapot.com:8081"